import { chain } from 'lodash';
import { StartingMaterialDatasetProviders } from '../starting-materials-providers';

export function findCheapestEntryOverall(items: any[]) {
  return chain(items)
    .shuffle()
    .sortBy('availabilityTier')
    .sortBy(item => Number(item.price) / Number(item.amount))
    .first()
    .value();
}

export function findCheapestEntryInLowestTier(items: any[]) {
  const lowestAvailabilityTier = chain(items)
    .map('availabilityTier')
    .uniq()
    .sortBy()
    .first()
    .value();

  return chain(items)
    .filter(['availabilityTier', lowestAvailabilityTier])
    .sortBy(item => Number(item.price) / Number(item.amount))
    .first()
    .value();
}

interface Compound {
  compoundName: string;
  normalizedSmiles: string;
  casNumber: string;
}
export const SM_PROVIDER_META = {
  [StartingMaterialDatasetProviders.Chemspace]: {
    name: 'Chemspace',
    generateLink(compound: Compound) {
      return `https://chem-space.com/${compound.compoundName}/`;
    },
  },
  [StartingMaterialDatasetProviders.Mcule]: {
    name: 'Mcule',
    generateLink(compound: Compound) {
      return `https://mcule.com/${compound.compoundName}/`;
    },
  },
  [StartingMaterialDatasetProviders.Emolecules]: {
    name: 'eMolecules',
    generateLink(compound: Compound) {
      return `https://orderbb.emolecules.com/search/#?smiles=${encodeURIComponent(
        compound.normalizedSmiles
      )}&searchtype=ex&system-type=BB&p=1`;
    },
  },
  [StartingMaterialDatasetProviders.Cas]: {
    name: 'SciFinder',
    generateLink() {
      return '';
    },
  },
  [StartingMaterialDatasetProviders.Molport]: {
    name: 'Molport',
    generateLink(compound: Compound, userEmail?: string) {
      let queryParams = '';
      if (
        userEmail &&
        !['molecule.one', 'molecule.wtf', 'm1ai.dev'].some(domain => userEmail.includes(domain))
      ) {
        queryParams = `?${new URLSearchParams({
          utm_source: '780028e2',
          utm_campaign: '4031cd9e',
        }).toString()}`;
      }
      return `https://www.molport.com/shop/compound/${compound.compoundName}${queryParams}`;
    },
  },
};
